import { Fragment, ReactNode, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  __BUDGETICON,
  __BUDGETICONBLACK,
  __CMDICON,
  __CMDICONBLACK,
  __MEDIAICON,
  __MEDIAICONBLACK,
  _EVENTICON,
  _EVENTICONBLACK,
} from "../../data/icons";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

type Props = {
  children?: ReactNode;
};

const CardContentData = [
  {
    id: "1",
    icon: _EVENTICON || "",
    hoverIcon: _EVENTICONBLACK || "",
    title: "Événements",
    link: "/evenements",
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },

  {
    id: "2",
    icon: __BUDGETICON || "",
    hoverIcon: __BUDGETICONBLACK || "",
    title: "Budget",
    link: "/budget",
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },

  {
    id: "3",
    icon: __CMDICON || "",
    hoverIcon: __CMDICONBLACK || "",
    title: "Commande publique",
    link: "/commande-publique",
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
  {
    id: "4",
    icon: __MEDIAICON || "",
    hoverIcon: __MEDIAICONBLACK || "",
    title: "Médiathèque",
    link: "/mediatheque",
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
];

const InformationHomeSection = (props: Props) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <Fragment>
      <div
        className="relative p-8 md:p-24"
        style={{
          zIndex: 0,
        }}
      >
        <div className="text-3xl font-bold text-center text-black">
          INFORMATIONS UTILES{" "}
        </div>

        <div className="flex justify-center mt-20">
          <div className="grid items-center justify-center grid-cols-1 gap-y-5 gap-x-96 lg:gap-3 lg:grid-cols-4 md:gap-5">
            {CardContentData.map((item, index) => (
              <div key={item.id}>
                <Link
                  to={item.link}
                  className="flex justify-center xl:flex-row"
                >
                  <Card
                    data-aos="flip-right"
                    className="hover:bg-[#3CC6F7] group p-16 w-[300px]   h-[300px] "
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <CardHeader className="w-full">
                      <CardTitle className="flex items-center justify-center ">
                        {" "}
                        <svg
                          className="w-full"
                          width="90"
                          height="90"
                          viewBox="0 0 83 83"
                          xmlns="http://www.w3.org/2000/svg"
                          dangerouslySetInnerHTML={{
                            __html:
                              hoveredIndex === index
                                ? item.hoverIcon
                                : item.icon,
                          }}
                        />
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-col items-center justify-center w-full ">
                      <p className="mt-3 font-bold group-hover:text-white whitespace-nowrap">
                        {item.title}
                      </p>
                    </CardContent>
                    <CardFooter className="justify-center w-full ">
                      <p className="text-primary group-hover:text-white">
                        Voir plus {">>"}
                      </p>
                    </CardFooter>
                  </Card>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default InformationHomeSection;
